import { createReducer } from '../../../../utils/ReduxUtils';
import * as types from '../../actionTypes';

const initialState = false;

const isLoading = () => true;

const isEnding = () => false;

export default createReducer(initialState, {
  [types.FETCH_USERS_REQUEST]: isLoading,
  [types.FETCH_USERS_SUCCESS]: isEnding,
  [types.FETCH_USERS_FAILURE]: isEnding,
});
